import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';

interface IProps {
  onClick: () => void;
}

const ClearFiltersButton: FC<IProps> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <Box display="flex" height="100%">
      <Button startIcon={<RefreshIcon />} variant="outlined" onClick={onClick} size="large">
        {t('analytics:clearFilters')}
      </Button>
    </Box>
  );
};

export default ClearFiltersButton;
